<template>
  <v-layout class="pa-2 mrow">
    <img class="c-align-self-start" src="@/assets/img/illustrations/purse.png" alt="cardboard box" width="56px">
    <div>
      <v-layout align-center>
        <router-link
        class="rlink-hover font-weight-medium color1--text"
        style="text-decoration: none;display:inline-flex;align-items: center;"
        :to="{ path: '/sale/' + item.sale_id}" @click.native.stop>
          Sale
          <span class="ml-1">{{ item.sale_id }}</span>
        </router-link>
        &nbsp;-&nbsp;
        <div class="caption text--text text--darken-1">
        {{ dateFromNow }}
        </div>
        <v-spacer></v-spacer>
        <v-chip v-if="!item.complete" 
        small disabled label class="caption" color="color1" text-color="white">
          in process
        </v-chip>
      </v-layout>
      <div>
        <c-metric-selector
        :inventoryItemID="item.inventory_item_id" 
        :realValue="item.quantity"
        labelMode
        alwaysScale
        ></c-metric-selector>
      </div>
      <div>
        {{ item.customer_name }}
      </div>
      <div class="caption text--text text--darken-1">
        {{ humanDate }}
      </div>
    </div>
    <!-- {{ item }} -->
  </v-layout>
</template>

<script>
export default {
  props: ['item'],
  computed: {
    humanDate () {
      if (this.$moment.utc(this.item.date_end).isValid()) {
        return this.$moment(this.item.date_end).format('ddd D MMM YYYY, h:mm')
      }
      return ''
    },
    dateFromNow () {
      if (this.$moment.utc(this.item.date_end).isValid()) {
        return this.$moment.utc(this.item.date_end).fromNow()
      }
      return ''
    }
  }
}
</script>

<style scoped lang="scss">
.mrow {
  border-bottom: thin solid;
}
</style>
